import type { CandidateStatusCode } from './types';

type CandidateStatusPresentation = {
  backgroundColor: string;
  color: string;
  label: string;
};

export const CANDIDATE_STATUS_PRESENTATION = {
  NEW: {
    backgroundColor: 'var(--mantine-color-primary-2)',
    color: 'var(--mantine-color-otherWhite-0)',
    label: 'Новый',
  },
  LOOKING: {
    backgroundColor: 'var(--mantine-color-secondary-2)',
    color: 'var(--mantine-color-secondary-9)',
    label: 'Ищет работу',
  },
  EMPLOYED: {
    backgroundColor: 'var(--mantine-color-green-2)',
    color: 'var(--mantine-color-green-9)',
    label: 'Работает',
  },
  CONSIDERING: {
    backgroundColor: 'var(--mantine-color-yellow-0)',
    color: 'var(--mantine-color-yellow-7)',
    label: 'Рассматривает предложения',
  },
  NOT_LOOKING: {
    backgroundColor: 'var(--mantine-color-tertiary-2)',
    color: 'var(--mantine-color-tertiary-9)',
    label: 'Не ищет работу',
  },
} satisfies Record<CandidateStatusCode, CandidateStatusPresentation>;
